<template>
    <div class="mt-1.5 sm:mt-3 flex items-center">
        <img
            src="/images/campaigns/green-checked-icon.svg"
            class="w-[14px]"
            alt="Green checked icon"
        />

        <p class="ml-2 leading-tight text-[14px] lg:text-[16px] text-[#2C2C4F]">
            <slot />
        </p>
    </div>
</template>
